// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q6bU","badges":"styles_badges__3SpKd"};